import React from "react";
import Header from "../components/Header";
import "../styles/Rental.scss";
import HomeOwnerRentalSection from "../components/Rental/HomeOwnerRentalSection";
import ActionsList from "../components/Rental/ActionsList";
import RentingSection from "../components/Rental/RentingSection";
import image1 from "../iamges/man1.png";
import image2 from "../iamges/man2.png";
import LogoWordmark from "../iamges/LogoWordmark.png";
import BottomSection from "../components/BottomSection";

const Rental = () => {
  return (
    <div className='RentalPage'>
      <Header />
      <div className='rental-first-section' />
      <HomeOwnerRentalSection />
      <ActionsList />
      <RentingSection />
      <div className='Rental-img'>
        <img src={image2} alt='image2' />
        <img src={image1} alt='image1' />
      </div>

      <div>
        <img src={LogoWordmark} alt='LogoWordmark' className='logoWordmark' />
      </div>

      <BottomSection />
    </div>
  );
};

export default Rental;
